import { useState } from "react";
import { Link } from "react-router-dom";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import logo from "@/main/assets/images/login/xnuup_main_logo_white.png";
import { RoutesConstants } from "@/main/routes/routesConstants";
import { getTranslateByKey } from "@/main/services/utils";

import Translates from "../translates/translates";
import Headermobile from "./headermobile/headermobile";
import RegisterMenu from "../registerMenu/registerMenu";
import * as S from "./styles";

export interface ISubPagesLinks {
	name: string;
	url: string;
}
function Header() {
	const [showMobileMenu, setShowMobileMenu] = useState(false);
	const SubPagesLinks: ISubPagesLinks[] = [
		{
			name: getTranslateByKey("information.home"),
			url: RoutesConstants.home,
		},
		{
			name: getTranslateByKey("information.forSuppliers"),
			url: RoutesConstants.homepageSupplier,
		},
		{
			name: getTranslateByKey("information.forBodyshops"),
			url: RoutesConstants.homepageBodyshop,
		},
		{
			name: getTranslateByKey("information.forInsurers"),
			url: RoutesConstants.homepageInsurer,
		},
		{
			name: getTranslateByKey("information.aboutUs"),
			url: RoutesConstants.homepageAbout,
		},
	];

	function toggleMobileMenu() {
		setShowMobileMenu((prev) => !prev);
	}

	function onClickToTop() {
		window.scrollTo({ top: 0 });
	}

	return (
		<S.AreaHeader>
			<S.ContainerNavBar>
				<S.NavBar>
					<Link to={RoutesConstants.home} onClick={onClickToTop}>
						<S.Logo src={logo} />
					</Link>
					{SubPagesLinks.map((link, index) => (
						<Link key={index} to={link.url} className="show-only-desktop" onClick={onClickToTop}>
							<S.SubPage>{link.name}</S.SubPage>
						</Link>
					))}
					<RegisterMenu className="show-only-desktop" />
					<S.Login to={RoutesConstants.login} className="show-only-desktop">
						{getTranslateByKey("information.login")}
					</S.Login>
					<S.MenuMobile>
						<IconButton onClick={toggleMobileMenu}>
							<MenuIcon />
						</IconButton>
					</S.MenuMobile>
					<Translates className="show-only-desktop" />

					<Headermobile
						subPagesLinks={SubPagesLinks}
						isMobileMenuOpen={showMobileMenu}
						toggleMobileMenu={toggleMobileMenu}
					/>
				</S.NavBar>
			</S.ContainerNavBar>
		</S.AreaHeader>
	);
}

export default Header;
